import { EnvironmentProviders, InjectionToken, makeEnvironmentProviders } from '@angular/core';

/**
 * The base every API call builds on, including the versioned prefix: the landed endpoints live
 * under `/api/v1/*`, so the value is e.g. `https://dev.api.rekruto.io/api/v1`. `url.util`'s
 * joinUrl() appends relative feature paths (`auth/login`, `candidate/refresh`, ...) onto it.
 *
 * Provided per app with `provideApiBaseUrl(environment.apiUrl)` - the token, never a raw
 * environment import, is what keeps the library buildable standalone and testable.
 */
export const API_BASE_URL = new InjectionToken<string>('RK_API_BASE_URL');

export function provideApiBaseUrl(baseUrl: string): EnvironmentProviders {
  return makeEnvironmentProviders([{ provide: API_BASE_URL, useValue: baseUrl }]);
}